import { FormFieldActions, FormFieldState } from '../../../hooks';
import { FormField, SearchField } from '@/components/custom/erp';
import { QUERY_KEYS } from '@/constants/query-keys';
import { taiKhoanSearchColumns } from '@/constants';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import Link from '@/platform/compat/link';

interface Props {
  formMode: 'add' | 'edit' | 'view';
  state: FormFieldState;
  actions: FormFieldActions;
}

export const AccountTab = ({ formMode, state, actions }: Props) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='space-y-2 p-4'>
      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk kho/ chi phí</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkKho?.code || ''}
          relatedFieldValue={state.tkKho?.name || ''}
          onRowSelection={actions.setTkKho}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'></Label>
        <FormField
          label='Cho phép sửa tài khoản vật tư khi nhập liệu trên chứng từ'
          className='flex items-center'
          labelClassName='min-w-36 font-medium'
          name='sua_tk_vt'
          type='checkbox'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk doanh thu</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkDoanhThu?.code || ''}
          relatedFieldValue={state.tkDoanhThu?.name || ''}
          onRowSelection={actions.setTkDoanhThu}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk giá vốn</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkGiaVon?.code || ''}
          relatedFieldValue={state.tkGiaVon?.name || ''}
          onRowSelection={actions.setTkGiaVon}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk chiết khấu</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkChietKhau?.code || ''}
          relatedFieldValue={state.tkChietKhau?.name || ''}
          onRowSelection={actions.setTkChietKhau}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk khuyến mãi</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkKhuyenMai?.code || ''}
          relatedFieldValue={state.tkKhuyenMai?.name || ''}
          onRowSelection={actions.setTkKhuyenMai}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk trả lại</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkTraLai?.code || ''}
          relatedFieldValue={state.tkTraLai?.name || ''}
          onRowSelection={actions.setTkTraLai}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk s/p dở dang</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkSPDD?.code || ''}
          relatedFieldValue={state.tkSPDD?.name || ''}
          onRowSelection={actions.setTkSPDD}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-36 font-medium'>Tk chi phí NVL</Label>
        <SearchField<AccountModel>
          displayRelatedField='name'
          columnDisplay='code'
          disabled={isViewMode}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={state.tkCPNVL?.code || ''}
          relatedFieldValue={state.tkCPNVL?.name || ''}
          onRowSelection={actions.setTkCPNVL}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Link className='text-blue-700 hover:underline' href='/danh-muc/doi-tuong/he-thong-tai-khoan/' prefetch={false}>
          * Danh mục tài khoản
        </Link>
      </div>
    </div>
  );
};
